const RANGE_FORMAT = new Intl.DateTimeFormat('cs-CZ', {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
});

const TERM_DATE_FORMAT = new Intl.DateTimeFormat('cs-CZ', {
  weekday: 'short',
  day: 'numeric',
  month: 'numeric',
});

/** Rozsah seriálu „1. 11. 2026 → 27. 12. 2026“ (read-only pole formuláře). */
export function formatDateRange(from: string | null, to: string | null): string {
  if (!from) return '—';
  const fromLabel = RANGE_FORMAT.format(new Date(from));
  if (!to) return fromLabel;
  return `${fromLabel} → ${RANGE_FORMAT.format(new Date(to))}`;
}

/** Datum termínu „Pá 6. 11. → So 7. 11.“ (sloupec Datum). */
export function formatTermDate(from: string, to: string | null): string {
  const fromLabel = TERM_DATE_FORMAT.format(new Date(from));
  if (!to) return fromLabel;
  return `${fromLabel} → ${TERM_DATE_FORMAT.format(new Date(to))}`;
}

const INTEGER_FORMAT = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 });
const ONE_DECIMAL_FORMAT = new Intl.NumberFormat('cs-CZ', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

/** Celé číslo se skupinami tisíců (cena/pax, „od X“). */
export function formatInteger(value: number): string {
  return INTEGER_FORMAT.format(value);
}

/** Jedno desetinné místo s desetinnou čárkou (marže „18,4“). */
export function formatOneDecimal(value: number): string {
  return ONE_DECIMAL_FORMAT.format(value);
}
